import React from "react";
import "./makeimpact.css";
import NonprofitSignup from "../../molecules/NonprofitSignup/NonprofitSignup";

function MakeImpact(props) {
   const [openModal,setOpenModal]=React.useState(false)
  return (
    <>
    <div className="impact_main">
      <h1>
        READY TO MAKE AN <br /> IMPACT?
      </h1>
      <h2>
      Join leading nonprofits creating meaningful change through purpose -driven commerce.
      </h2>

      <div className="impact_btn_div">
        <button onClick={()=>setOpenModal(true)} className="impact_btn">Partner With Us</button>
      </div>
    </div>
    <NonprofitSignup partner={true} isBrand={true} isOpen={openModal} onClose={()=>setOpenModal(false)} onSubmitForm={()=>setOpenModal(false)} />
    
    </>
  );
}

export default MakeImpact;
